import { useQuery } from "@tanstack/react-query"
import { getClientContactInfo } from "@/api"

export const useClientContactInfo = () => {
  return useQuery({
    queryKey: ["clientContactInfo"],
    queryFn: getClientContactInfo,
  })
}
